import React from "react";

import { exists } from "@examspark/common";
import {
  useAppContext,
  useQueryGetCourseUnits,
  useQueryGetUserClassrooms,
} from "@examspark/common-app";
import { Label, SelectInput } from "@examspark/common-ui";
import {
  HybridField,
  useHybridState,
} from "@examspark/common-ui/dist/utils/useHybridComponent";
import { Classroom, Unit } from "@examspark/types";

// Allow the ClassroomUnitPicker component to work by JUST passing
// in unit get/setters (if you dont care about classrooms) or to capture both
// if you need both. You could also pass in nothing but that wouldnt be useful
type UnitPickerProps = HybridField<{
  unit: Unit | null;
}> &
  HybridField<{
    classroom: Classroom | null;
  }>;
export const ClassroomUnitSelect = (props: UnitPickerProps) => {
  const [context] = useAppContext();

  const [classroom, setClassroom] = useHybridState<Classroom | null>({
    initialValue: null,
    value: props.classroom,
    onValueChange: props.onClassroomChange,
  });

  const [unit, setUnit] = useHybridState<Unit | null>({
    initialValue: null,
    value: props.unit,
    onValueChange: props.onUnitChange,
  });

  const classroomsQuery = useQueryGetUserClassrooms(
    context.workspaceUser?.id,
    context.user?.id,
  );
  const unitsInClassroomQuery = useQueryGetCourseUnits(classroom?.course?.id);

  const classrooms = classroomsQuery.data
    ?.filter(exists)
    .map((c) => c.classroom)
    .filter(exists)
    .map((c) => ({
      label: c.name ?? "",
      value: c.id,
      classroom: c,
    }));

  return (
    <>
      <div data-cy="assign-to-classroom-classroom">
        <Label label="Classroom">
          <SelectInput
            options={classrooms}
            value={classroom?.id}
            isClearable
            onChange={(v) => {
              setClassroom(
                classrooms?.find((c) => c.value === v?.value)?.classroom ??
                  null,
              );
            }}
          />
        </Label>
      </div>
      <div data-cy="assign-to-classroom-unit">
        <Label label="Unit">
          <SelectInput
            options={unitsInClassroomQuery.data?.map((u) => ({
              label: u.name ?? "",
              value: u.id,
            }))}
            value={unit?.id}
            disabled={!classroom}
            isClearable
            onChange={(v) => {
              setUnit(
                unitsInClassroomQuery.data?.find((u) => u.id === v?.value) ??
                  null,
              );
            }}
          />
        </Label>
      </div>
    </>
  );
};
